<template>
    <transition name="expand"
                @enter="expandEnter"
                @after-enter="expandAfterEnter"
                @leave="expandLeave"
    >
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        name:    "HeightTransition",
        methods: {
            expandEnter: function (target) {
                const width = getComputedStyle(target).width;

                target.style.width      = width;
                target.style.position   = 'absolute';
                target.style.visibility = 'hidden';
                target.style.height     = 'auto';

                const height = getComputedStyle(target).height;

                target.style.width      = null;
                target.style.position   = null;
                target.style.visibility = null;
                target.style.height     = 0;

                getComputedStyle(target).height;
                setTimeout(() => target.style.height = height);

                this.$emit('enter', target)
            },

            expandAfterEnter: function (target) {
                target.style.height = 'auto'

                this.$emit('after-enter', target)
            },

            expandLeave: function (target) {
                const height        = getComputedStyle(target).height
                target.style.height = height
                setTimeout(() => target.style.height = '0')
                this.$emit('leave', target)
            }
        }
    }
</script>

<style scoped>
    * {
        will-change: height;
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .expand-enter-active,
    .expand-leave-active {
        transition: height 1s ease-in-out;
        overflow: hidden;
    }

    .expand-enter,
    .expand-leave-to {
        height: 0;
    }
</style>
